const defaultCustomT = {
  letterSpacing: 0,
};

export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 900,
};

export const fontSize = {
  h1: 96,
  h2: 64,
  h3: 48,
  titleMedium: 24,
  titleSmall: 18,
  contentLarge: 16,
  contentMedium: 14,
  contentSmall: 12,
  extraSmall: 10,
};

const typography = {
  htmlFontSize: 16,
  fontFamily: 'Avenir LT Pro',
  size: {
    size75: '0.75rem',
    size80: '0.80rem',
    size90: '0.90rem',
    size110: '1.1rem',
    size115: '1.15rem',
    size120: '1.2rem',
    size150: '1.5rem',
    size200: '2rem',
  },
  weight: {
    weight100: '100',
    weight200: '200',
    weight300: '300',
    weight400: '400',
    weight500: '500',
    weight600: '600',
    weight700: '700',
    weight900: '900',
  },
  h1: {
    fontFamily: 'Avenir',
    fontWeight: 900,
    fontSize: '2rem',
    lineHeight: '3rem',
  },
  h2: {
    fontFamily: 'Avenir',
    fontWeight: 900,
    fontSize: '1.5rem',
    lineHeight: '2.25rem',
  },
  h3: {
    fontFamily: 'Avenir',
    fontWeight: 900,
    fontSize: '1.125rem',
    lineHeight: '1.688rem',
  },
  titleBlack: {
    fontFamily: 'Avenir',
    fontWeight: 900,
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
  titleMedium: {
    fontFamily: 'Avenir',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
  contentBlack: {
    fontFamily: 'Avenir',
    fontWeight: 900,
    fontSize: '0.875rem',
    lineHeight: '1.313rem',
  },
  contentMedium: {
    fontFamily: 'Avenir',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.313rem',
  },
  contentBook: {
    fontFamily: 'Avenir',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.313rem',
  },
  smallBlack: {
    fontFamily: 'Avenir',
    fontWeight: 900,
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
  },
  smallMedium: {
    fontFamily: 'Avenir',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
  },
  'h1/bold': {
    ...defaultCustomT,
    fontSize: fontSize.h1,
    fontWeight: fontWeight.bold,
    lineHeight: `${fontSize.h1}px`,
  },
  'h2/bold': {
    ...defaultCustomT,
    fontSize: fontSize.h2,
    fontWeight: fontWeight.bold,
    lineHeight: `${fontSize.h2}px`,
  },
  'h3/semibold': {
    ...defaultCustomT,
    fontSize: fontSize.h2,
    fontWeight: fontWeight.bold,
    lineHeight: `${fontSize.h2}px`,
  },
  'title-medium/regular': {
    ...defaultCustomT,
    fontSize: fontSize.titleMedium,
    fontWeight: fontWeight.regular,
    lineHeight: `${fontSize.titleMedium}px`,
  },
  'title-medium/semibold': {
    ...defaultCustomT,
    fontSize: fontSize.titleMedium,
    fontWeight: fontWeight.semiBold,
    lineHeight: `${fontSize.titleMedium}px`,
  },
  'title-medium/extrabold': {
    ...defaultCustomT,
    fontSize: fontSize.titleMedium,
    fontWeight: fontWeight.extraBold,
    lineHeight: `${fontSize.titleMedium}px`,
  },
  'title-small/extrabold': {
    ...defaultCustomT,
    fontSize: fontSize.titleSmall,
    fontWeight: fontWeight.extraBold,
    lineHeight: `${fontSize.titleSmall}px`,
  },
  'title-small/regular': {
    ...defaultCustomT,
    fontSize: fontSize.titleSmall,
    fontWeight: fontWeight.regular,
    lineHeight: `${fontSize.titleSmall}px`,
  },
  'title-small/semibold': {
    ...defaultCustomT,
    fontSize: fontSize.titleSmall,
    fontWeight: fontWeight.semiBold,
    lineHeight: `${fontSize.titleSmall}px`,
  },
  'content-large/extrabold': {
    ...defaultCustomT,
    fontSize: fontSize.contentLarge,
    fontWeight: fontWeight.extraBold,
    lineHeight: `${fontSize.contentLarge}px`,
  },
  'content-large/semibold': {
    ...defaultCustomT,
    fontSize: fontSize.contentLarge,
    fontWeight: fontWeight.semiBold,
    lineHeight: `${fontSize.contentLarge}px`,
  },
  'content-large/medium': {
    ...defaultCustomT,
    fontSize: fontSize.contentLarge,
    fontWeight: fontWeight.medium,
    lineHeight: `${fontSize.contentLarge}px`,
  },
  'content-large/regular': {
    ...defaultCustomT,
    fontSize: fontSize.contentLarge,
    fontWeight: fontWeight.regular,
    lineHeight: `${fontSize.contentLarge}px`,
  },
  'content-medium/extrabold': {
    ...defaultCustomT,
    fontSize: fontSize.contentMedium,
    fontWeight: fontWeight.extraBold,
    lineHeight: `${fontSize.contentMedium}px`,
  },
  'content-medium/regular': {
    ...defaultCustomT,
    fontSize: fontSize.contentMedium,
    fontWeight: fontWeight.regular,
    lineHeight: `${fontSize.contentMedium}px`,
  },
  'content-medium/medium': {
    ...defaultCustomT,
    fontSize: fontSize.contentMedium,
    fontWeight: fontWeight.medium,
    lineHeight: `${fontSize.contentMedium}px`,
  },
  'content-medium/semibold': {
    ...defaultCustomT,
    fontSize: fontSize.contentMedium,
    fontWeight: fontWeight.semiBold,
    lineHeight: `${fontSize.contentMedium}px`,
  },
  'content-small/regular': {
    ...defaultCustomT,
    fontSize: fontSize.contentSmall,
    fontWeight: fontWeight.regular,
    lineHeight: `${fontSize.contentSmall}px`,
  },
  'content-small/extraBold': {
    ...defaultCustomT,
    fontSize: fontSize.contentSmall,
    fontWeight: fontWeight.extraBold,
    lineHeight: `${fontSize.contentSmall}px`,
  },
  'content-small/medium': {
    ...defaultCustomT,
    fontSize: fontSize.contentSmall,
    fontWeight: fontWeight.medium,
    lineHeight: `${fontSize.contentSmall}px`,
  },
  'content-small/semibold': {
    ...defaultCustomT,
    fontSize: fontSize.contentSmall,
    fontWeight: fontWeight.semiBold,
    lineHeight: `${fontSize.contentSmall}px`,
  },
  'extra-small/semibold': {
    ...defaultCustomT,
    fontSize: fontSize.extraSmall,
    fontWeight: fontWeight.semiBold,
    lineHeight: `${fontSize.extraSmall}px`,
  },
  'extra-small/light': {
    ...defaultCustomT,
    fontSize: fontSize.extraSmall,
    fontWeight: fontWeight.light,
    lineHeight: `${fontSize.extraSmall}px`,
    marginTop: '1px',
  },
};

export default typography;
